export default "__VITE_ASSET__BAnhR63K__"